import type { ReactNode } from "react";

export interface ProjectTaskDetailSectionProps {
  readonly id?: string;
  readonly icon?: ReactNode;
  readonly label: string;
  readonly children: ReactNode;
}

export function ProjectTaskDetailSection({
  id,
  icon,
  label,
  children,
}: ProjectTaskDetailSectionProps) {
  return (
    <section id={id} className="scroll-mt-12 space-y-1.5">
      <h3 className="flex items-center gap-1.5 text-xs font-medium uppercase tracking-wide text-muted-foreground">
        {icon ? (
          <span className="inline-flex size-3.5 items-center justify-center">{icon}</span>
        ) : null}
        {label}
      </h3>
      {children}
    </section>
  );
}
